import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find-index";import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";import clsx from 'clsx';
import capitalize from "../../../../helpers/capitalize";
import React from 'react';

import { createStyles } from "./styles";







/**
 * List of marketing tags that are displayed in the portfolio (if it has multiple products) or on each card
 * Only those tags are shown whose ids are in the list of Portfolio attributes
 */
var MarketingTagsList = function MarketingTagsList(_ref)




{var marketingTagIds = _ref.marketingTagIds,marketingTags = _ref.marketingTags,portfolioId = _ref.portfolioId,listStyles = _ref.listStyles;
  var classes = createStyles();

  var TagItems = _mapInstanceProperty(marketingTagIds).call(marketingTagIds, function (tagId) {var _marketingTags$find, _context;
    // Get name of tag from the list of all available tags
    var currentTagName = ((_marketingTags$find = _findInstanceProperty(marketingTags).call(marketingTags, function (tag) {return tag.id === tagId;})) === null || _marketingTags$find === void 0 ? void 0 : _marketingTags$find.tag) || '';
    var currentTagIndex = _findIndexInstanceProperty(marketingTags).call(marketingTags, function (tag) {return tag.id === tagId;});
    var uniqueTagId = _concatInstanceProperty(_context = "".concat(portfolioId, "-")).call(_context, tagId);

    return /*#__PURE__*/(
      React.createElement("p", {
        key: uniqueTagId,
        id: uniqueTagId,
        className: clsx(
        classes.marketingTag,
        currentTagIndex >= 0 && classes["tag".concat(currentTagIndex)]) },


      capitalize(currentTagName)));


  });

  return /*#__PURE__*/React.createElement("div", { className: clsx(classes.marketingTagsWrapper, listStyles) }, TagItems);
};

export default MarketingTagsList;
//# sourceMappingURL=index.js.map